// Footer.js
import React from 'react';
import logo from '../assets/logo-bvt.png';

const Footer = () => {
  return (
    <footer className="bg-[#f9f9f9] text-gray-700 mt-16 pt-10 pb-6 px-6 rounded-t-3xl shadow-inner">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8 text-center md:text-left">
        <div className="flex flex-col items-center md:items-start">
          <img src={logo} alt="Logo" className="h-12 mb-2" />
          <p className="text-sm text-gray-500 mt-2">
            Soluciones en infraestructura, energía y servicios especializados.
          </p>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-3">Navegación</h3>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:text-[#003366]">Inicio</a></li>
            <li><a href="/servicios" className="hover:text-[#003366]">Servicios</a></li>
            <li><a href="/nosotros" className="hover:text-[#003366]">Nosotros</a></li>
            <li><a href="/contacto" className="hover:text-[#003366]">Contacto</a></li>
          </ul>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-3">Contacto</h3>
          <p className="text-sm"><strong>Razón Social:</strong> INVERSIONES BVT, C.A.</p>
          <p className="text-sm"><strong>RIF:</strong> J-29987858-8</p>
          <p className="text-sm"><strong>Email:</strong> info@inversionesbvt.com</p>
          <p className="text-sm"><strong>Teléfonos:</strong> +58 261-7981181 / +1 754-2991058 / +58 414-6358199 / +58 412-0628220</p>
          <p className="text-sm"><strong>Dirección:</strong> Calle 67 con av. 8B Local 9 PB, Maracaibo</p>
        </div>
      </div>
      <div className="mt-8 text-center text-xs text-gray-400">
        © {new Date().getFullYear()} Inversiones BVT C.A. Todos los derechos reservados.
      </div>
    </footer>
  );
};

export default Footer;
